///////////////////////////////////////////////////////////////////////////////////
// Retrieve NOUS API Key
////////////////////////////////////////////////////////////////////////////////////
var nous_api_data;
// jQuery.ajax({
//      type: "POST",
//      // async: false,
//      url: '/wp-admin/admin-ajax.php',
//      dataType: 'json',
//      data: {
//       'action' : 'nous_retrieve_api_data',
//      },
//      success:function(response) {

//         ////////////////////////////////////////////////////////////////////////////////////
//         // Set API Data
//         ////////////////////////////////////////////////////////////////////////////////////
//         nous_api_data = response;

//         ////////////////////////////////////////////////////////////////////////////////////
//         // Set Global Ajax Settings
//         ////////////////////////////////////////////////////////////////////////////////////
//         jQuery.ajaxSetup({
//           headers: {
//             'X-Api-Key': response.client_key,
//           }
//         });

//         ////////////////////////////////////////////////////////////////////////////////////
//         // Display Forms
//         ////////////////////////////////////////////////////////////////////////////////////
//         jQuery('form').css('opacity', '1');

//      },
// });

////////////////////////////////////////////////////////////////////////////////////
// Persistant Session Storage
////////////////////////////////////////////////////////////////////////////////////
if (!sessionStorage.length) {
  // Ask other tabs for session storage
  localStorage.setItem('getSessionStorage', Date.now());
};

window.addEventListener('storage', function(event) {

  if (event.key == 'getSessionStorage') {

    localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
    localStorage.removeItem('sessionStorage');

  } else if (event.key == 'sessionStorage' && !sessionStorage.length) {
    // sessionStorage is empty -> fill it

    var data = JSON.parse(event.newValue),
          value;

    for (key in data) {
      sessionStorage.setItem(key, data[key]);
    }

  }
});

////////////////////////////////////////////////////////////////////////////////////
// Generate Google reCaptcha V3 Token
////////////////////////////////////////////////////////////////////////////////////
function generate_google_recaptcha_token(action) {
  return new Promise(function(resolve, reject) {
      grecaptcha.execute(jQuery('body').attr('data-recaptcha-key'), {
        action: action
      })
      .then(function(token) {

        ////////////////////////////////////////////////////////////////////////////////////
        // Ajax - Validate Response
        ////////////////////////////////////////////////////////////////////////////////////
        jQuery.ajax({
          type: "POST",
          url: '/wp-admin/admin-ajax.php',
          data: {
            'action':'ajax_recaptcha_validate',
            'captcha_token' : token,
            'captcha_action' : action,
          },
          success:function(response) {
            resolve(response);
          }
        });
      });
  });
}
////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////////////////
// Header Offset
////////////////////////////////////////////////////////////////////////////////////
function getHeaderOffset() {

  ////////////////////////////////////////////////////////////////////////////////////
  // Variables
  ////////////////////////////////////////////////////////////////////////////////////
  var headerOuterHeight = 0;

  ////////////////////////////////////////////////////////////////////////////////////
  // Get Sticky Header Outer Height
  ////////////////////////////////////////////////////////////////////////////////////
  if (jQuery('header').hasClass('js-sticky-top')) {
    headerOuterHeight = jQuery('header').outerHeight() + 20;
  }

  ////////////////////////////////////////////////////////////////////////////////////
  // Return Header Outer Height
  ////////////////////////////////////////////////////////////////////////////////////
  return headerOuterHeight;

}
////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////////////////
// Mandrill JSON Payload
////////////////////////////////////////////////////////////////////////////////////
function mandrill_json_payload(fid) {

  ////////////////////////////////////////////////////////////////////////////////////
  // Declare Form Data Object Array
  ////////////////////////////////////////////////////////////////////////////////////
  var mandrillData = new Object();
  mandrillData.customFields = {}
  var mandrillAttachments = []

  ////////////////////////////////////////////////////////////////////////////////////
  // Mandrill Settings
  ////////////////////////////////////////////////////////////////////////////////////
  mandrillData.recipients = jQuery(fid).data('form-recipients'); // Form Recipients
  mandrillData.fromName = jQuery(fid).data('form-from-name'); // From Name
  mandrillData.fromEmail = jQuery(fid).data('form-from-email-address'); // From Email Address
  mandrillData.subjectLine = jQuery(fid).data('form-subject-line'); // Form Subject Line
  mandrillData.notificationCopy = jQuery(fid).data('form-email-body'); // Email Body Copy

  ////////////////////////////////////////////////////////////////////////////////////
  // Get all data fields
  ////////////////////////////////////////////////////////////////////////////////////
  jQuery( fid + ' *[data-field-name]' ).each(function( index, value ) {

    ////////////////////////////////////////////////////////////////////////////////////
    // Grouped Field Type - Checkboxs | Radio Buttons
    ////////////////////////////////////////////////////////////////////////////////////
    if(jQuery(this).is('[data-field-group]')) {

      var groupedID = jQuery(this).data('field-group');
      var groupedValue = [];

      ////////////////////////////////////////////////////////////////////////////////////
      // Push Array of checked fields
      ////////////////////////////////////////////////////////////////////////////////////
      jQuery( this ).find('[name="' + groupedID + '"]').each(function( index ) {
        if(jQuery(this).is(':checked')) {
          groupedValue.push(jQuery(this).val());
        }
      });

      ////////////////////////////////////////////////////////////////////////////////////
      // Append Group Data to data
      ////////////////////////////////////////////////////////////////////////////////////
      if(groupedValue.length) {
        mandrillData.customFields[jQuery(this).data('field-name')] = groupedValue.join();
      }

    ////////////////////////////////////////////////////////////////////////////////////
    // Standard Field Type
    ////////////////////////////////////////////////////////////////////////////////////
    } else {
      mandrillData.customFields[jQuery(this).data('field-name')] = jQuery(this).val();
    }

  });

  ////////////////////////////////////////////////////////////////////////////////////
  // Attachments
  ////////////////////////////////////////////////////////////////////////////////////
  jQuery( fid + ' *[data-file-base-64]' ).each(function( index, value ) {

    mandrillAttachments.push({
      'name' : jQuery(this).attr('data-filename'),
      'type' : jQuery(this).attr('data-mimetype'),
      'content' : jQuery(this).attr('data-file-base-64')
    });

  });

  ////////////////////////////////////////////////////////////////////////////////////
  // Assign Attachments
  ////////////////////////////////////////////////////////////////////////////////////
  if(mandrillAttachments.length > 0) {
    mandrillData['attachments'] = mandrillAttachments;
  }

  ////////////////////////////////////////////////////////////////////////////////////
  // Return Data
  ////////////////////////////////////////////////////////////////////////////////////
  return JSON.stringify(mandrillData);

}
////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////////////////
// Sticky Header
////////////////////////////////////////////////////////////////////////////////////
function nous_sticky_scroll_header() {
  var header = jQuery("body").find('header');
  var show_logo = "sticky-logo-show";
  var scroll_up = "sticky-scroll-up";
  var scroll_down = "sticky-scroll-down";

  var last_scroll_position = 0;

  function handleScroll() {
    var current_scroll_position = jQuery(window).scrollTop();

    // Check if user is scrolling up - less then or equal to 150px from top
    if (current_scroll_position <= 150) {
      header.removeClass(scroll_down).removeClass(scroll_up);
    }
    // Check if user is scrolling up
    else if (current_scroll_position < last_scroll_position) {
      header.removeClass(scroll_down).addClass(scroll_up);
    }
    // User is scrolling down
    else {
      header.removeClass(scroll_up).addClass(scroll_down);
    }

    // Update scroll position
    last_scroll_position = current_scroll_position;
  }

  // Run on scroll
  jQuery(window).scroll(handleScroll);

  // Run on initial load
  handleScroll();
}
////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////////////////
// NOUS Anchor Link Hash
////////////////////////////////////////////////////////////////////////////////////
function nous_anchor_link_hash(hash) {
  // Exclude "Chosen" (https://harvesthq.github.io/chosen/) dropdowns from hash scroll
  // as they are not compatible with the scroll to hash functionality
  // - no hash present, results in a JS error
  if (jQuery(this).hasClass('chosen-single')) {
    return;
  }
  
  // Fixed Nav Offset
  var header_offset = getHeaderOffset();
  
  // Scroll to w/ Animation
  if(jQuery('*[data-scroll-element="' + hash + '"]').length) {
    jQuery('html, body').animate({
      scrollTop: jQuery('*[data-scroll-element="' + hash + '"]').offset().top - header_offset
    }, 0);
  }
}
////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////////////////
// Flexi Block: Map
////////////////////////////////////////////////////////////////////////////////////
function flexi_block_map_block() {
  (function( $ ) {

    /**
     * initMap
     *
     * Renders a Google Map onto the selected jQuery element
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @return  object The map instance.
     */
    function initMap( $el ) {
    
        // Find marker elements within map.
        var $markers = $el.find('.marker');
    
        // Create gerenic map.
        var mapArgs = {
          disableDefaultUI: true,
          zoom        : $el.data('zoom') || 16,
          mapTypeId   : google.maps.MapTypeId.ROADMAP,
          styles      : [
            {
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#212121"
                }
              ]
            },
            {
              "elementType": "labels.icon",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#757575"
                }
              ]
            },
            {
              "elementType": "labels.text.stroke",
              "stylers": [
                {
                  "color": "#212121"
                }
              ]
            },
            {
              "featureType": "administrative",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#757575"
                }
              ]
            },
            {
              "featureType": "administrative.country",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#9e9e9e"
                }
              ]
            },
            {
              "featureType": "administrative.land_parcel",
              "stylers": [
                {
                  "visibility": "off"
                }
              ]
            },
            {
              "featureType": "administrative.locality",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#bdbdbd"
                }
              ]
            },
            {
              "featureType": "poi",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#757575"
                }
              ]
            },
            {
              "featureType": "poi.park",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#181818"
                }
              ]
            },
            {
              "featureType": "poi.park",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#616161"
                }
              ]
            },
            {
              "featureType": "poi.park",
              "elementType": "labels.text.stroke",
              "stylers": [
                {
                  "color": "#1b1b1b"
                }
              ]
            },
            {
              "featureType": "road",
              "elementType": "geometry.fill",
              "stylers": [
                {
                  "color": "#2c2c2c"
                }
              ]
            },
            {
              "featureType": "road",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#8a8a8a"
                }
              ]
            },
            {
              "featureType": "road.arterial",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#373737"
                }
              ]
            },
            {
              "featureType": "road.highway",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#3c3c3c"
                }
              ]
            },
            {
              "featureType": "road.highway.controlled_access",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#4e4e4e"
                }
              ]
            },
            {
              "featureType": "road.local",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#616161"
                }
              ]
            },
            {
              "featureType": "transit",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#757575"
                }
              ]
            },
            {
              "featureType": "water",
              "elementType": "geometry",
              "stylers": [
                {
                  "color": "#000000"
                }
              ]
            },
            {
              "featureType": "water",
              "elementType": "labels.text.fill",
              "stylers": [
                {
                  "color": "#3d3d3d"
                }
              ]
            }
          ]
        };
        var map = new google.maps.Map( $el[0], mapArgs );
    
        // Add markers.
        map.markers = [];
        $markers.each(function(){
          initMarker( $(this), map );
        });
    
        // Center map based on markers.
        centerMap( map );
    
        // Return map instance.
        return map;
    }
    
    /**
     * initMarker
     *
     * Creates a marker for the given jQuery element and map.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   jQuery $el The jQuery element.
     * @param   object The map instance.
     * @return  object The marker instance.
     */
    function initMarker( $marker, map ) {
        var marker_url = $marker.data('marker-url');

        // Get position from marker.
        var lat = $marker.data('lat');
        var lng = $marker.data('lng');
        var latLng = {
            lat: parseFloat( lat ),
            lng: parseFloat( lng )
        };
    
        // Create marker instance.
        var marker = new google.maps.Marker({
            position : latLng,
            map: map,
            icon: marker_url
        });
    
        // Append to reference for later use.
        map.markers.push( marker );
    
        // If marker contains HTML, add it to an infoWindow.
        if( $marker.html() ){
    
            // Create info window.
            var infowindow = new google.maps.InfoWindow({
                content: $marker.html()
            });
    
            // Show info window when marker is clicked.
            google.maps.event.addListener(marker, 'click', function() {
                infowindow.open( map, marker );
            });
        }
    }
    
    /**
     * centerMap
     *
     * Centers the map showing all markers in view.
     *
     * @date    22/10/19
     * @since   5.8.6
     *
     * @param   object The map instance.
     * @return  void
     */
    function centerMap( map ) {
    
        // Create map boundaries from all map markers.
        var bounds = new google.maps.LatLngBounds();
        map.markers.forEach(function( marker ){
          bounds.extend({
            lat: marker.position.lat(),
            lng: marker.position.lng()
          });
        });
    
        // Case: Single marker.
        if( map.markers.length == 1 ) {
          map.setCenter( bounds.getCenter() );
        // Case: Multiple markers.
        } else {
          map.fitBounds( bounds );
        }
    }
    
    // Render maps on page load.
    $(document).ready(function(){
      $('.section-flexi-map-block .flexi-map-block-map .acf-map').each(function() {
        var map = initMap( $(this) );
      });
    });
    
    })(jQuery);
}
////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////////////////
// Flexi Block: Project Spotlight
////////////////////////////////////////////////////////////////////////////////////
function flexi_block_project_spotlight_block() {
  (function($) {

    var block = $('.section-flexi-project-spotlight-block');

    block.each(function() {
      var screen_width = $(window).width();
      var breakpoint_size = 768;

      var hover_image_wrapper = block.find('.flexi-project-spotlight-block-spotlight-image');
      var hover_image = hover_image_wrapper.find('.js-project-image');
      var default_hover_image = hover_image_wrapper.find('.js-default-image');

      if (screen_width >= breakpoint_size) {

        $(this).find('.flexi-project-spotlight-block-spotlight-projects .js-card-project-hover')
          .on('mouseenter', function() {
            var hover_image_url = $(this).attr('data-image-url');
            
            hover_image.attr('src', hover_image_url);
            
            hover_image.removeClass('opacity-0');
            default_hover_image.addClass('opacity-0');

          })
          .on('mouseleave', function() {
            
            default_hover_image.removeClass('opacity-0');
            hover_image.addClass('opacity-0');

          });

      } // ENDIF

    });
  })(jQuery);
}
////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////////////////
// Flexi Block: Before & After
////////////////////////////////////////////////////////////////////////////////////
function flexi_block_before_after_block() {
  const sliders = document.querySelectorAll('.ba-slider');

  sliders.forEach(slider => {
    const before = slider.querySelector('.ba-before-image');
    const beforeImage = before.getElementsByTagName('img')[0];

    const after = slider.querySelector('.ba-after-image');
    const afterImage = after.getElementsByTagName('img')[0];

    const resizer = slider.querySelector('.ba-slider-resizer');

    let active = false;

    // Function to set image widths
    function setImageWidths() {
      let width = slider.offsetWidth;
      console.log(width);
      beforeImage.style.width = width + 'px';
      afterImage.style.width = width + 'px';

      beforeImage.style.maxWidth = width + 'px';
      afterImage.style.maxWidth = width + 'px';
    }

    // Sort overflow out for Overlay Image
    document.addEventListener("DOMContentLoaded", function() {
      setImageWidths();
    });

    // Adjust width of image on resize 
    window.addEventListener('resize', function() {
      setImageWidths();
    });

    // Ensure images are fully loaded before applying styles
    beforeImage.addEventListener('load', setImageWidths);
    afterImage.addEventListener('load', setImageWidths);

    resizer.addEventListener('mousedown',function(){
      active = true;
      resizer.classList.add('resize');
    });

    document.body.addEventListener('mouseup',function(){
      active = false;
      resizer.classList.remove('resize');
    });

    document.body.addEventListener('mouseleave', function() {
      active = false;
      resizer.classList.remove('resize');
    });

    document.body.addEventListener('mousemove',function(e){
      if (!active) return;
      let x = e.pageX;
      x -= slider.getBoundingClientRect().left;
      slideIt(x);
      pauseEvent(e);
    });

    resizer.addEventListener('touchstart',function(){
      active = true;
      resizer.classList.add('resize');
    });

    document.body.addEventListener('touchend',function(){
      active = false;
      resizer.classList.remove('resize');
    });

    document.body.addEventListener('touchcancel',function(){
      active = false;
      resizer.classList.remove('resize');
    });

    //calculation for dragging on touch devices
    document.body.addEventListener('touchmove',function(e){
      if (!active) return;
      let x;
      
      let i;
      for (i=0; i < e.changedTouches.length; i++) {
        x = e.changedTouches[i].pageX; 
      }
      
      x -= slider.getBoundingClientRect().left;
      slideIt(x);
      pauseEvent(e);
    });

    function slideIt(x) {
      let transform = Math.max(0,(Math.min(x,slider.offsetWidth)));
      before.style.width = transform+"px";
      resizer.style.left = transform-0+"px";
    }

    //stop divs being selected.
    function pauseEvent(e) {
      if(e.stopPropagation) e.stopPropagation();
      if(e.preventDefault) e.preventDefault();
      e.cancelBubble=true;
      e.returnValue=false;
      return false;
    }
  });
}
////////////////////////////////////////////////////////////////////////////////////

////////////////////////////////////////////////////////////////////////////////////
// Document Ready
////////////////////////////////////////////////////////////////////////////////////
jQuery( document ).ready(function($) {

  ////////////////////////////////////////////////////////////////////////////////////
  // Anchor Link Hash
  ////////////////////////////////////////////////////////////////////////////////////
  $(document).on('click', 'a', function() {

    var hash = $(this).attr('href').split('#');
    nous_anchor_link_hash(hash[1]);

  });

  ////////////////////////////////////////////////////////////////////////////////////
  // Site Wide Variables
  ////////////////////////////////////////////////////////////////////////////////////
  var nousThemeName = $('body').attr('data-nous-theme');
  var googleMapStyles = [{"featureType":"all","elementType":"labels.text.fill","stylers":[{"saturation":36},{"color":"#333333"},{"lightness":40}]},{"featureType":"all","elementType":"labels.text.stroke","stylers":[{"visibility":"on"},{"color":"#ffffff"},{"lightness":16}]},{"featureType":"all","elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"featureType":"administrative","elementType":"geometry.fill","stylers":[{"color":"#fefefe"},{"lightness":20}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#fefefe"},{"lightness":17},{"weight":1.2}]},{"featureType":"landscape","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":20}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#f5f5f5"},{"lightness":21}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#dedede"},{"lightness":21}]},{"featureType":"road.highway","elementType":"geometry.fill","stylers":[{"color":"#ffffff"},{"lightness":17}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#ffffff"},{"lightness":29},{"weight":0.2}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":18}]},{"featureType":"road.local","elementType":"geometry","stylers":[{"color":"#ffffff"},{"lightness":16}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#f2f2f2"},{"lightness":19}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#e9e9e9"},{"lightness":17}]}];

  ////////////////////////////////////////////////////////////////////////////////////
  // Determine if is retina device
  ////////////////////////////////////////////////////////////////////////////////////
  function isRetinaDisplay() {
    if (window.matchMedia) {
      var mq = window.matchMedia("only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)");
      return (mq && mq.matches || (window.devicePixelRatio > 1));
    }
  }

  ////////////////////////////////////////////////////////////////////////////////////
  // Base64 File
  ////////////////////////////////////////////////////////////////////////////////////
  function base64File(file, onLoadCallback) {
      return new Promise(function(resolve, reject) {
          var reader = new FileReader();
          reader.onload = function() { resolve(reader.result); };
          reader.onerror = reject;
          reader.readAsDataURL(file);
      });
  }

  ////////////////////////////////////////////////////////////////////////////////////
  // Generate Munchkin Hash
  ////////////////////////////////////////////////////////////////////////////////////
  function generate_munchkin_hash(email) {

    return $.ajax({
      type: "POST",
      url: '/wp-admin/admin-ajax.php',
      data: 'email=' + email + '&action=generate_munchkin_hash',
      dataType: 'json',
    });

  }

  ////////////////////////////////////////////////////////////////////////////////////
  // Google Maps Init
  ////////////////////////////////////////////////////////////////////////////////////
  function init_google_map() {

    ////////////////////////////////////////////////////////////////////////////////////
    // Each Google Map
    ////////////////////////////////////////////////////////////////////////////////////
    $( '.js-init-google-map' ).each(function( index ) {

        ////////////////////////////////////////////////////////////////////////////////////
        // Variables
        ////////////////////////////////////////////////////////////////////////////////////
        var myLatLng = {lat: $(this).data('lat'), lng: $(this).data('lng')};
        // var mapInfoWindow = $(this).attr('data-info-window');
        // var markerIcon = new google.maps.MarkerImage('/wp-content/themes/' + nousThemeName + '/assets/img/map-marker.png', null, null, null, new google.maps.Size(30,40));


        ////////////////////////////////////////////////////////////////////////////////////
        // Create Map
        ////////////////////////////////////////////////////////////////////////////////////
        var map = new google.maps.Map(document.getElementById($(this).attr('id')), {
          zoom: 12,
          center: myLatLng,
          styles: googleMapStyles
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Create Marker
        ////////////////////////////////////////////////////////////////////////////////////
        var marker = new google.maps.Marker({
          position: myLatLng,
          map: map,
        });

        ////////////////////////////////////////////////////////////////////////////////////
        // Create Info Window
        ////////////////////////////////////////////////////////////////////////////////////
        var infowindow = new google.maps.InfoWindow({
          content: mapInfoWindow,
          // pixelOffset: new google.maps.Size(5, 20)
        });
        infowindow.open(map, marker);

    }); // END EACH

  }

  ////////////////////////////////////////////////////////////////////////////////////
  // Onload Functionality
  ////////////////////////////////////////////////////////////////////////////////////
  $(window).load(function() {

      ////////////////////////////////////////////////////////////////////////////////////
      // Hash Onload Scroll To Functionality
      ////////////////////////////////////////////////////////////////////////////////////
      if(window.location.hash) {

        setTimeout(function() {

          var hash = window.location.hash;
          hash = hash.split('#');

          nous_anchor_link_hash(hash[1]);

        }, 500);

      } // END HASH

      ////////////////////////////////////////////////////////////////////////////////////
      // Initialize Google Map
      ////////////////////////////////////////////////////////////////////////////////////
      init_google_map();

      ////////////////////////////////////////////////////////////////////////////////////
      // Trunc8 Function
      ////////////////////////////////////////////////////////////////////////////////////
      $( '.js-trunc8' ).each(function( index ) {

        var lineCount = $(this).attr('data-trunc8-line');

        $(this).trunk8({
          lines: parseInt(lineCount)
        });

      });

  }); // END ONLOAD


  ////////////////////////////////////////////////////////////////////////////////////
  // Clear input on focus
  ////////////////////////////////////////////////////////////////////////////////////
  $(document).on('focus', '.js-clear-input', function() {

    $(this).val('');

    return false;

  });

  ////////////////////////////////////////////////////////////////////////////////////
  // Initialize Marketo Instance
  ////////////////////////////////////////////////////////////////////////////////////
  // $.ajax({
  //   url: '//munchkin.marketo.net/munchkin.js',
  //   dataType: 'script',
  //   cache: true,
  //   success: function() {
  //     Munchkin.init('[KEY]');
  //   }
  // });

  ////////////////////////////////////////////////////////////////////////////////////
  // Save To Disk Function
  ////////////////////////////////////////////////////////////////////////////////////
  // function SaveToDisk(fileURL, fileName) {
  //     // for non-IE
  //     if (!window.ActiveXObject) {
  //         var save = document.createElement('a');
  //         save.href = fileURL;
  //         save.target = '_blank';
  //         save.download = fileName || 'unknown';

  //         var evt = new MouseEvent('click', {
  //             'view': window,
  //             'bubbles': true,
  //             'cancelable': false
  //         });
  //         save.dispatchEvent(evt);

  //         (window.URL || window.webkitURL).revokeObjectURL(save.href);
  //     }

  //     // for IE < 11
  //     else if ( !! window.ActiveXObject && document.execCommand)     {
  //         var _window = window.open(fileURL, '_blank');
  //         _window.document.close();
  //         _window.document.execCommand('SaveAs', true, fileName || fileURL)
  //         _window.close();
  //     }
  // }

  ////////////////////////////////////////////////////////////////////////////////////
  // Scroll To Event
  ////////////////////////////////////////////////////////////////////////////////////
  // $(document).on('click', '.js-scroll-to', function() {

  //   // Scroll to
  //   var scrollTo = $(this).attr('data-scroll-to');

  //   // Header Position Offset
  //   if($('.header-top').css('position') === 'fixed') {
  //     var headerHeight = $('.js-navbar-fixed-top').outerHeight();
  //   } else {
  //     var headerHeight = 0;
  //   }

  //   $('html, body').animate({
  //    scrollTop: $('*[data-scroll-element="' + scrollTo + '"]').offset().top
  //   }, 0);

  //   return false;

  // });

  ////////////////////////////////////////////////////////////////////////////////////
  // Marketo IE10 Bug fix
  ////////////////////////////////////////////////////////////////////////////////////
  (function () {
    'use strict';
    if (navigator.userAgent.match(/IEMobile\/10\.0/)) {
      var msViewportStyle = document.createElement('style')
      msViewportStyle.appendChild(
        document.createTextNode(
          '@-ms-viewport{width:auto!important}'
        )
      )
      document.querySelector('head').appendChild(msViewportStyle)
    }
  })();

  ////////////////////////////////////////////////////////////////////////////////////
  // File Type - Data Attributes
  ////////////////////////////////////////////////////////////////////////////////////
  $(document).on('change', '.js-base64-file', function() {

     ////////////////////////////////////////////////////////////////////////////////////
     // Base64 File Contents
     ////////////////////////////////////////////////////////////////////////////////////
     var inputID = $(this).attr('id');
     var fileInput = document.querySelector('#' + inputID).files[0];

     ////////////////////////////////////////////////////////////////////////////////////
     // Assign Base64 to file
     ////////////////////////////////////////////////////////////////////////////////////
     var fileInputBase64 = base64File(fileInput, function(e) {
     }).then(function(result) {
      var formatted = result.split(',');
      $('#' + inputID).attr('data-file-base-64', formatted[1]);
     });

     ////////////////////////////////////////////////////////////////////////////////////
     // Assign other attributes to file input
     ///////////////////////////////////////////////////////////////////////////////////
     $('#' + inputID).attr('data-filename', fileInput.name);
     $('#' + inputID).attr('data-mimetype', fileInput.type);

  });

  ////////////////////////////////////////////////////////////////////////////////////
  // FAQ accordion toggle functionality
  ////////////////////////////////////////////////////////////////////////////////////
  $(document).on('click', '.js-panel', function() {

      $('.panel-collapse').removeClass('in');

      if($(this).parent('.panel').hasClass('active')) {
        $(this).parent('.panel').removeClass('active');
        $(this).siblings('.panel-collapse').removeClass('in');
      } else {
        $('.js-panel').parent('.panel').removeClass('active');
        $(this).parent('.panel').addClass('active');
        $(this).siblings('.panel-collapse').addClass('in');
      }

      return false;
  });

  ////////////////////////////////////////////////////////////////////////////////////
  // jQuery Validate Phone Method - Uses Google Lib
  ////////////////////////////////////////////////////////////////////////////////////
  $.validator.addMethod("validPhone", function(value, element) {

      if(value == '') { return true; }

      try {

          var phoneUtil = i18n.phonenumbers.PhoneNumberUtil.getInstance();
          var number = phoneUtil.parseAndKeepRawInput(value, 'AU');

          if(phoneUtil.isValidNumber(number)) {

              return true;

          } else {

              return false;

          }

      }
      catch(ex) {
          return false;
          console.log(ex);
      }

  }, "Please enter a valid phone number (including area code for land lines)");

});